import { useCallback, useMemo } from "react";
import type { ReactFlowInstance } from "@xyflow/react";
import {
  KG_INSPECTOR_FOCUS_DURATION_MS,
  KG_INSPECTOR_FOCUS_MAX_ZOOM,
  KG_INSPECTOR_FOCUS_PADDING,
} from "../kgViewport.constants";
import { focusViewportOnNodes } from "../utils/kgViewportFocus";

interface UseKgCanvasFocusOptions {
  focusNode: (targetId: string) => string | null;
  reactFlow: ReactFlowInstance | null;
}

/**
 * Inspector → canvas navigation: select node and smoothly center the viewport.
 */
export const useKgCanvasFocus = ({
  focusNode,
  reactFlow,
}: UseKgCanvasFocusOptions) => {
  const focusNodeOnCanvas = useCallback(
    (targetId: string) => {
      const resolvedId = focusNode(targetId);
      if (!resolvedId || !reactFlow) return;

      focusViewportOnNodes(reactFlow, [resolvedId], {
        padding: KG_INSPECTOR_FOCUS_PADDING,
        duration: KG_INSPECTOR_FOCUS_DURATION_MS,
        maxZoom: KG_INSPECTOR_FOCUS_MAX_ZOOM,
      });
    },
    [focusNode, reactFlow],
  );

  return useMemo(
    () => ({ focusNode: focusNodeOnCanvas }),
    [focusNodeOnCanvas],
  );
};
